// extracted by mini-css-extract-plugin
export default {"content":"TestPage_content__acaoZ"};